<template>
  <hypto-popup :title="webhookOptions.title">
    <template v-slot:body>
      <p>Do you want to <b>{{webhookOptions.type.toLowerCase()}} {{webhookOptions.text}}</b> webhook?</p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="doAction" :disabled="isDisableButton">Proceed</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/webhooks'
import { mapMutations } from 'vuex'
import formMixins from '@/mixins/formMixins'

export default {
  name: 'ToggleWebhook',
  components: { HyptoPopup },
  props: {
    webhookOptions: Object
  },
  mixins: [formMixins],
  methods: {
    ...mapMutations(['SET_POPUP_NAME']),
    doAction () {
      if (this.webhookOptions.type === 'Enable') {
        this.enableWebhook()
      } else {
        this.disableWebhook()
      }
    },
    enableWebhook () {
      ApiServices.enableWebhook(this.webhookOptions.category).then((response) => {
        this.handleResponse(response)
      })
    },
    disableWebhook () {
      ApiServices.disableWebhook(this.webhookOptions.category).then((response) => {
        this.handleResponse(response)
      })
    },
    handleResponse (response) {
      if (response.success) {
        this.successToastMsg(response.message)
        this.SET_POPUP_NAME(null)
        this.$emit('refreshWebhook')
      } else {
        this.errorToastMsg(response.message)
      }
      this.enableButton()
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/themes/main.scss';

  p {
    font-size: 15px;
    color: $secondary;
  }
</style>
